// src/services/activityService.js
import { repo } from '../dbservice/repo';

class ActivityService {
  subscribeToUsers(cb) {
    return repo.subscribeToUpdates('users', [], [], null, (d) => cb(d || []));
  }
  subscribeToAssets(cb) {
    return repo.subscribeToUpdates('assets', [], [], null, (d) => cb(d || []));
  }
  subscribeToCompanies(cb) {
    return repo.subscribeToUpdates('companies', [], [], null, (d) => cb(d || []));
  }
  subscribeToAuditLogs(cb) {
    return repo.subscribeToUpdates(
      'auditLogs', [], [{ field: 'timestamp', order: 'desc' }], 50, (d) => cb(d || [])
    );
  }
}

export const activityService = new ActivityService();